import { createContext } from 'react';
import { checkinKeyProps } from '../../hooks/useCheckinKey';

export default createContext<checkinKeyProps>({ canCheckIn: false, isPositionEnabled: null, isLocationEnabled: null });